import React from 'react'
import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'
import themeVars from 'ui_theme/site/globals/site.variables'

import { Flex } from 'shared/ui'
import { propFunc } from 'util/functions'
import { emptyArr } from 'util/arrays'

import RemovableRecipient from './RemovableRecipient'
import AddContact from './AddContact'

const OldList = ({
  allowMultipleRecipients,
  className,
  recipients = emptyArr,
  onRemove,
  startEditing,
  type,
  children,
}) => {
  const showAddContact =
    (allowMultipleRecipients || recipients.length === 0) && startEditing
  return (
    <Flex
      flex="1 1 auto"
      className={className}
      css={`
        width: 100%;
      `}
    >
      {recipients.map(recipient => {
        return (
          <RemovableRecipient
            className="recipient"
            key={recipient.id || recipient.email}
            user={recipient}
            allUsers={recipients}
            onClick={propFunc(onRemove, recipient, type)}
          />
        )
      })}
      {showAddContact && (
        <AddContact className="addContact" onClick={startEditing} />
      )}
      {children}
    </Flex>
  )
}

const OldStyledList = styled(OldList)`
  flex-wrap: wrap;

  .recipient {
    display: flex;
    margin-right: 4px;
  }

  .addContact:not(:only-child) {
    margin-left: ${th('space.2')}px;
    opacity: 0;
    transition: opacity 300ms ease;
  }

  :hover .addContact {
    opacity: 1;
  }
`

// eslint-disable-next-line react/no-multi-comp
function SUIList(props) {
  const {
    allowMultipleRecipients,
    children,
    focused,
    onRemove,
    recipients,
    startEditing,
    type,
  } = props

  const showAddTrigger =
    (allowMultipleRecipients || recipients.length === 0) && startEditing

  return (
    <Flex
      flex="1 1 auto"
      css={`
        width: 100%;
        flex-wrap: wrap;
        align-items: center;
        padding: 11px 16px;
        border-radius: ${themeVars.defaultBorderRadius};
        border: 1px solid ${focused ? themeVars.groovy : themeVars.dust};
        background-color: white;

        & > *:not(:last-child) {
          margin-right: ${themeVars.mini};
        }
      `}
    >
      {recipients.map(recipient => {
        return (
          <RemovableRecipient
            css={`
              margin-bottom: 0;
            `}
            className="recipient"
            key={recipient.id || recipient.email}
            user={recipient}
            allUsers={recipients}
            onClick={propFunc(onRemove, recipient, type)}
          />
        )
      })}
      {showAddTrigger && (
        <div
          css={`
            flex-grow: 1;
            height: 100%;
            min-height: 18px;
            cursor: pointer;
          `}
          onClick={startEditing}
        />
      )}
      {children}
    </Flex>
  )
}

// eslint-disable-next-line react/no-multi-comp
export default function List(props) {
  const { sui, ...rest } = props

  if (sui) return <SUIList {...rest} />

  return <OldStyledList {...rest} />
}
